const content = [
  // 第二章 第一节
  // 章标题
  {
    key: 'section2',
    type: "title",
    category: 1, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    shortText: "第<span style=\"font-family:'Times New Roman'\">2<\/span>章", // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: '文旌数字教材', // *必填* 标题文本内容
    textStyle: {
      // fontFamily: 'Arial', // 字体，本地配置的字体
      // fontSize: 32, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 2, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 2, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#333', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      // backgroundImage: require("@/assets/images/bookContent/top_bg.png") // 背景图片  默认：无
    }
  },
  // 节标题
  {
    key: 'section2.1',
    type: "title",
    category: 2, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    shortText: "<span style=\"font-family:'Times New Roman'\">2<\/span>．<span style=\"font-family:'Times New Roman'\">1<\/span>", // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: '数字教材概述', // *必填* 标题文本内容
    textStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      // fontSize: 26, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#333', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
    },
  },
  // 小标题
  {
    key: 'section2.1.1',
    type: "title",
    category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: "<span style=\"font-family:'Times New Roman'\">1<\/span>．数字教材的定义", // *必填* 标题文本内容
    textStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      // fontSize: 26, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#333', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
    },
  },
  // 交互 刮一刮
  {
    key: 'section2.1.1。1', // *必填* 唯一标识
    type: 'action', // *必填* 类型：交互
    actionType: 3, // 交互类型 1：连连看 2：排一排 3：刮一刮 4：拼图/组装
    title: '思考：什么是数字教材？', // 标题
    titleStyle: {},
    isBlock: 2, // 是否默认存在一个区域框
    content: {
      // 刮一刮
      key: 'action4.1',
      title: '刮一刮内容1',
      cover: require("@/assets/images/bookContent/图1-1  机器学习与人类思考的类比.png"),
    },
  },
  // 小标题
  {
    key: 'section2.1.2',
    type: "title",
    category: 3, // *必填* 分类 1：章头 2：节头 3：小标题 ...
    // shortText: '1.1', // 小标题文本，有值的时候展示 例如：第一章、第一节等
    text: "<span style=\"font-family:'Times New Roman'\">2<\/span>．纸质教材与数字教材的区别", // *必填* 标题文本内容
    textStyle: {
      // fontFamily: 'Microsoft Yahei', // 字体，本地配置的字体
      // fontSize: 26, // 文字大小  默认：26
      // lineHeight: 40, // 行高  默认：46
      // textIndent: 0, // 首行缩进  默认：0 可以使用距离px也可以使用字节数2em
      // fontWeight: 'normal', // 加粗 bold：加粗 normal：不加粗  默认：加粗
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#333', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
      // backgroundImage: require("@/assets/images/bookContent/chapter_title_bg.png") // 背景图片  默认：无
    },
  },
  // 正文
  {
    key: 'section2.1.2.1', // *必填* 唯一标识
    type: 'text', // *必填* 类型：正文
    content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
      {
        key: 'section2.1.2.1.1', // *必填* 唯一标识
        category: 'text', // *必填* 内容类型 text：文本 
        text: '纸质教材与数字教材在交互性、动态性、多元性、针对性、便携性等方面存在区别（见表', // *必填* 文本内容
        textStyle: {
        },
      },
      {
        key: 'section2.1.2.1.2', // *必填* 唯一标识
        category: 'text', // *必填* 内容类型 text：文本 
        text: '1', // *必填* 文本内容
        textStyle: {
          fontFamily: 'Times New Roman', // 字体，本地配置的字体
        },
      },
      {
        key: 'section2.1.2.1.3', // *必填* 唯一标识
        category: 'text', // *必填* 内容类型 text：文本 
        text: '）。', // *必填* 文本内容
        textStyle: {
        },
      },
    ],
    textStyle: {
      // fontFamily: 'xxx', // 字体，本地配置的字体
      // fontSize: 20, // 文字大小  默认：20
      // lineHeight: 40, // 行高  默认：36
      textIndent: '2em', // 首行缩进  默认：40 或者可以使用字节数2em
      // fontWeight: 'bold', // 加粗 bold：加粗 normal：不加粗  默认：normal
      // underline: 1, // 下划线 1：有下划线 2：无下划线  默认：2
      // fontItalic: 1, // 斜体 1：斜体 2：正常  默认：2
      // textAlign: 'left', // 文字对齐方式 left：左 right：右 center：居中  默认：left
      // color: '#333', // 文本颜色  默认：#00a8ac
      // backgroundColor: '#FFF', // 背景颜色  默认：无
    },
  },
  // 表格
  {
    key: 'section2.1.2.2', // *必填* 唯一标识
    type: 'table', // *必填* 类型：表格
    // 表格 的数据
    content: [
      {
        key: 'section2.1.2.2.1', // *必填* 唯一标识
        tabText: '详解版',
        tableHeader: [
          { label: "区别", prop: "tableLabel1", width: 137 },
          { label: "纸质教材", prop: "tableLabel2" },
          { label: "数字教材", prop: "tableLabel3" },
        ],
        tableData: [
          {
            tableLabel1: {
              key: 'section2.1.2.2.1.table1.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table1.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '交互性', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'center'
              },
            },
            
            tableLabel2: {
              key: 'section2.1.2.2.1.table1.2', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table1.2.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '依赖于传统的课堂讲授模式，缺乏交互功能，无法实现信息化的教学互动和学习结果跟踪', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
            tableLabel3: {
              key: 'section2.1.2.2.1.table1.3', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table1.3.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '提供人人交互、人机交互的功能，如模拟操作、互动练习、实时讨论、学习报告等，能够进一步增加课堂的生动性和趣味性，提升学生的参与度，提高学生的学习积极性', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
          },
          {
            tableLabel1: {
              key: 'section2.1.2.2.1.table2.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table2.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '动态性', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'center'
              },
            },
            
            tableLabel2: {
              key: 'section2.1.2.2.1.table2.2', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table2.2.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '内容是固化的，更新需要重新印刷，过程较慢且成本较高', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
            tableLabel3: {
              key: 'section2.1.2.2.1.table2.3', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table2.3.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '教材内容是动态更新的，紧跟学科及行业发展与变化，随时将新技术、新工艺、新标准等内容更新优化到教材中', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
          },
          {
            tableLabel1: {
              key: 'section2.1.2.2.1.table3.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table3.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '多元性', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'center'
              },
            },
            
            tableLabel2: {
              key: 'section2.1.2.2.1.table3.2', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table3.2.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '呈现形式较单一，主要依赖于文字和图片', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
            tableLabel3: {
              key: 'section2.1.2.2.1.table3.3', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table3.3.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '可以包含丰富的多媒体元素，如高清图片、视频、音频、动画、三维模型等多种形式的媒体，丰富教学内容，强化学生对知识的理解', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
          },
          {
            tableLabel1: {
              key: 'section2.1.2.2.1.table4.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table4.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '针对性', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'center'
              },
            },
            
            tableLabel2: {
              key: 'section2.1.2.2.1.table4.2', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table4.2.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '线下阅读无法直接运用互联网、人工智能等技术，难以实现个性化学习', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
            tableLabel3: {
              key: 'section2.1.2.2.1.table4.3', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table4.3.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '可运用互联网、人工智能等技术手段，容易实现搜索、标注、自主测验等功能，便于有针对性地进行个性化学习', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
          },
          {
            tableLabel1: {
              key: 'section2.1.2.2.1.table5.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table5.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '便携性', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'center'
              },
            },
            
            tableLabel2: {
              key: 'section2.1.2.2.1.table5.2', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table5.2.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '纸质书籍，自带重量，阅读和携带不方便', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
            tableLabel3: {
              key: 'section2.1.2.2.1.table5.3', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.1.table5.3.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '可使用手机、平板电脑等移动设备学习，便于随身携带，且不受携带数量限制，实现', // *必填* 文本内容
                  textStyle: {},
                },
                // 正文-气泡
                {
                  key: 'section2.1.2.2.1.table5.3.2', // *必填* 唯一标识
                  category: 'popover', // *必填* 内容类型 pop：气泡
                  text: '泛在学习', // *必填* 文本内容
                  // popTitle: '表格内的气泡', // 气泡的标题 气泡的标题与内容至少需要存在一个
                  popText: '在任何情境或场景中进行的学习。', // 气泡的内容
                  popLink: 'https://www.zgbk.com/ecph/words?SiteID=1&ID=121171&Type=bkzyb&SubID=49207', // 跳转地址，百科气泡需要一个跳转地址，根据样式确定是否需要一个popLinkIcon作为百科的标志或者跳转的入口
                  // 文字部分内容特殊样式配置
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
          },
        ]
      },
      {
        key: 'section2.1.2.2.2', // *必填* 唯一标识
        tabText: '提炼版',
        tableHeader: [
          { label: "区别", prop: "tableLabel1", width: 137 },
          { label: "纸质教材", prop: "tableLabel2" },
          { label: "数字教材", prop: "tableLabel3" },
        ],
        tableData: [
          {
            tableLabel1: {
              key: 'section2.1.2.2.2.table1.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table1.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '交互性', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'center'
              },
            },
            
            tableLabel2: {
              key: 'section2.1.2.2.2.table1.2', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table1.2.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '缺乏交互功能', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
            tableLabel3: {
              key: 'section2.1.2.2.2.table1.3', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table1.3.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '有人人交互、人机交互功能', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
          },
          {
            tableLabel1: {
              key: 'section2.1.2.2.2.table2.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table2.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '动态性', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'center'
              },
            },
            
            tableLabel2: {
              key: 'section2.1.2.2.2.table2.2', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table2.2.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '内容固化，更新慢且成本高', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
            tableLabel3: {
              key: 'section2.1.2.2.2.table2.3', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table2.3.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '内容动态更新', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
          },
          {
            tableLabel1: {
              key: 'section2.1.2.2.2.table3.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table3.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '多元性', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'center'
              },
            },
            
            tableLabel2: {
              key: 'section2.1.2.2.2.table3.2', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table3.2.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '形式单一，以文字和图片为主', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
            tableLabel3: {
              key: 'section2.1.2.2.2.table3.3', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table3.3.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '可以包含多媒体元素', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
          },
          {
            tableLabel1: {
              key: 'section2.1.2.2.2.table4.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table4.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '针对性', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'center'
              },
            },
            
            tableLabel2: {
              key: 'section2.1.2.2.2.table4.2', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table4.2.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '无法直接运用互联网、人工智能等技术实现个性化学习', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
            tableLabel3: {
              key: 'section2.1.2.2.2.table4.3', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table4.3.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '可运用互联网、人工智能等技术手段进行个性化学习', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
          },
          {
            tableLabel1: {
              key: 'section2.1.2.2.2.table5.1', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table5.1.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '便携性', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'center'
              },
            },
            
            tableLabel2: {
              key: 'section2.1.2.2.2.table5.2', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table5.2.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '纸质书籍为载体，阅读和携带不方便', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
            tableLabel3: {
              key: 'section2.1.2.2.2.table5.3', // *必填* 唯一标识
              type: 'text', // *必填* 类型：正文
              content: [ // *必填* 正文内容 兼容存在气泡超链接等情况，所以传递数组，即纯文本数组只有一项
                {
                  key: 'section2.1.2.2.2.table5.3.1', // *必填* 唯一标识
                  category: 'text', // *必填* 内容类型 text：文本 
                  text: '移动设备为载体，便于携带，且不受数量限制', // *必填* 文本内容
                  textStyle: {},
                },
              ],
              textStyle: {
                textAlign: 'left'
              },
            },
          },
        ]
      }
    ],
    title: "表<span style=\"font-family:'Times New Roman'\">1<\/span>&nbsp;&nbsp;&nbsp;&nbsp;纸质教材<span style=\"font-family:'Times New Roman'\">VS<\/span>数字教材", // 标题
    // width: 'xxxx', // 内容区域宽度 非必填 默认100%
    titleStyle: {
      
    }
  },
]
export default content